"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyChallengeToken = void 0;
var verifyToken_1 = require("./verifyToken");
var verifyChallengeToken = function (args) { return (0, verifyToken_1.verifyToken)(args); };
exports.verifyChallengeToken = verifyChallengeToken;
